import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { Services } from '@/components/sections/Services';
import { AboutBackground } from '@/components/sections/AboutBackground';
import { Partners } from '@/components/sections/Partners';
import { CtaScheduling } from '@/components/sections/CtaScheduling';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        <Header />
        
        <main>
          <Hero />
          <Services />
          <AboutBackground />
          <Partners />
          <CtaScheduling />
        </main>
        
        <Footer />
      </div>
    </>
  );
}